/**
 * en-GB messages added by Phase 2 task W13 (docs/PHASE-2-PLAN.md). Only that task edits this file.
 * Flat keys, `{name}` placeholders, merged into enGB by ./index.ts.
 */
export const w13EnGB = {
    // Shared by every public link page
    'publicLinks.loading': 'Loading your page…',
    'publicLinks.invalid.title': 'This link is not working',
    'publicLinks.invalid.body': 'It may have expired, been replaced by a newer one, or been used already. If you need a new link, please ask the person who sent it to you.',
    'publicLinks.rateLimited': 'Too many attempts. Please wait a minute and try again.',
    'publicLinks.problem.title': 'Something went wrong',
    'publicLinks.retry': 'Try again',
    'publicLinks.logoAlt': '{name} logo',
    'publicLinks.footer': 'You are using a private link. Please do not forward it.',
    'publicLinks.saved': 'Saved',
    // Pre-arrival page
    'publicLinks.pre.title': 'Your visit to {site}',
    'publicLinks.pre.hello': 'Hello {name}',
    'publicLinks.pre.expected': 'You are expected on {when}.',
    'publicLinks.pre.expectedUntil': 'Your pass works until {when}.',
    'publicLinks.pre.pending': 'Your visit is waiting for approval. We will let you know.',
    'publicLinks.pre.cancelled': 'This visit has been cancelled.',
    'publicLinks.pre.noShow': 'This visit has passed. Please contact your host if you still need to visit.',
    'publicLinks.pre.rejected': 'This visit was not approved. Please contact your host.',
    'publicLinks.pre.arrived': 'You have arrived. Thank you for getting this ready.',
    'publicLinks.pre.progress': 'Getting ready',
    'publicLinks.pre.progressCount': '{done} of {total} done',
    'publicLinks.pre.step.confirm': 'Confirm your visit',
    'publicLinks.pre.step.questions': 'Answer a few questions',
    'publicLinks.pre.step.notices': 'Read and accept the notices',
    'publicLinks.pre.step.photo': 'Add a photo',
    'publicLinks.pre.step.car': 'Add your car registration',
    'publicLinks.pre.confirm.button': 'Yes, I will be there',
    'publicLinks.pre.confirm.done': 'Thank you, you have confirmed your visit.',
    'publicLinks.pre.reschedule.title': 'Need a different time?',
    'publicLinks.pre.reschedule.date': 'New date',
    'publicLinks.pre.reschedule.time': 'New time',
    'publicLinks.pre.reschedule.message': 'Message to your host (optional)',
    'publicLinks.pre.reschedule.button': 'Ask for this time',
    'publicLinks.pre.reschedule.invalid': 'Please choose a date and time.',
    'publicLinks.pre.cancel.title': 'Cannot come?',
    'publicLinks.pre.cancel.message': 'Message to your host (optional)',
    'publicLinks.pre.cancel.button': 'Cancel my visit',
    'publicLinks.pre.cancel.confirm': 'Yes, cancel my visit',
    'publicLinks.pre.where.title': 'Getting there',
    'publicLinks.pre.where.address': 'Address',
    'publicLinks.pre.where.directions': 'Directions',
    'publicLinks.pre.where.map': 'Open the map',
    'publicLinks.pre.where.parking': 'Parking',
    'publicLinks.pre.where.wifi': 'Wi-Fi',
    'publicLinks.pre.where.wifiNetwork': 'Network: {network}',
    'publicLinks.pre.where.wifiPassword': 'Password: {password}',
    'publicLinks.pre.host.title': 'Your host',
    'publicLinks.pre.host.call': 'Call {name}',
    'publicLinks.pre.host.email': 'Email {name}',
    'publicLinks.pre.qr.title': 'Your sign-in code',
    'publicLinks.pre.qr.help': 'Show this code at the screen when you arrive and you can sign in quickly.',
    'publicLinks.pre.qr.alt': 'Sign-in code for your visit',
    'publicLinks.pre.questions.title': 'A few questions',
    'publicLinks.pre.questions.save': 'Save my answers',
    'publicLinks.pre.notices.title': 'Notices',
    'publicLinks.pre.notices.help': 'Please read these before you arrive.',
    'publicLinks.pre.notices.accepted': 'Accepted',
    'publicLinks.pre.notices.agree': 'I have read and accept this notice',
    'publicLinks.pre.notices.signHere': 'Please sign below',
    'publicLinks.pre.notices.accept': 'Accept notice',
    'publicLinks.pre.notices.needSign': 'Please sign before accepting.',
    'publicLinks.pre.notices.needAgree': 'Please tick the box to accept.',
    'publicLinks.pre.sign.canvas': 'Signature area. Draw your signature with your finger or mouse.',
    'publicLinks.pre.sign.clear': 'Clear signature',
    'publicLinks.pre.photo.title': 'Your photo',
    'publicLinks.pre.photo.help': 'A clear photo of your face helps reception and your badge. You can take one now or choose one from your phone.',
    'publicLinks.pre.photo.choose': 'Take or choose a photo',
    'publicLinks.pre.photo.change': 'Choose a different photo',
    'publicLinks.pre.photo.done': 'Photo added',
    'publicLinks.pre.photo.failed': 'We could not use that photo. Please try another one.',
    'publicLinks.pre.photo.notImage': 'Please choose a picture file.',
    'publicLinks.pre.car.title': 'Car registration',
    'publicLinks.pre.car.label': 'Registration number',
    'publicLinks.pre.car.help': 'Leave it empty if you are not driving.',
    'publicLinks.pre.car.save': 'Save registration',
    // Feedback page
    'publicLinks.fb.title': 'How was your visit?',
    'publicLinks.fb.at': 'Your visit to {site}',
    'publicLinks.fb.rating': 'Your rating',
    'publicLinks.fb.star': '{n} out of 5',
    'publicLinks.fb.low': 'Poor',
    'publicLinks.fb.high': 'Excellent',
    'publicLinks.fb.comment': 'Anything you would like to add? (optional)',
    'publicLinks.fb.send': 'Send my feedback',
    'publicLinks.fb.change': 'Change my answer',
    'publicLinks.fb.thanks': 'Thank you for your feedback.',
    'publicLinks.fb.thanksChange': 'You can change your answer for 24 hours after sending it.',
    'publicLinks.fb.locked': 'Your answer has been sent and can no longer be changed.',
    'publicLinks.fb.pick': 'Please choose a rating from 1 to 5.',
    'publicLinks.fb.unsub.title': 'Stop feedback emails',
    'publicLinks.fb.unsub.body': 'We will not ask you for feedback again. This does not affect any visit you have booked.',
    'publicLinks.fb.unsub.button': 'Stop feedback emails',
    'publicLinks.fb.unsub.done': 'Done. You will not get feedback emails from us again.',
    // Host action page
    'publicLinks.host.title': 'Reply about {name}',
    'publicLinks.host.site': 'At {site}',
    'publicLinks.host.action.on_my_way': 'Tell {name} you are on your way',
    'publicLinks.host.action.please_wait': 'Ask {name} to wait',
    'publicLinks.host.action.running_late': 'Tell us {name} is running late',
    'publicLinks.host.action.cancelled': 'Cancel the visit by {name}',
    'publicLinks.host.confirm': 'Send this reply',
    'publicLinks.host.done': 'Done. Your reply has been sent.',
    'publicLinks.host.unavailable': 'This reply is no longer needed. The visit has already finished or been cancelled.',
    // Companion link landing page
    'publicLinks.app.title': 'Open the CloudSign app',
    'publicLinks.app.body': 'Use the CloudSign app on your Android phone to see your site, check in and get notices. This link signs you in once, so open it on the phone with the app.',
    'publicLinks.app.open': 'Open in the CloudSign app',
    'publicLinks.app.store': 'Get the app on Google Play',
    'publicLinks.app.noApp': 'If nothing happens, install the app first and then open this link again.',
    'publicLinks.app.once': 'The link can only be used once and stops working soon, so please do it now.',
};
//# sourceMappingURL=w13.js.map